<template>
  <div class="fill-height">
    <div
      v-if="multipleRooms.switchContent == 'default'"
      class="pa-2"
    >
      <v-row
        style="margin: 0"
      >
        <v-col
          v-for="room in rooms"
          :key="room.id"
          cols="12"
          sm="6"
          md="4"
          lg="2"
        >
          <v-card
            class="text-center"
            @click="$router.push(`/room-${room.id}`)"
          >
            <v-card-title>
              {{ room.name }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <content-page
      v-if="multipleRooms.switchContent == 'content_page' && multipleRooms.switchContentConfig"
      :config="multipleRooms.switchContentConfig"
    />
    <iframe
      v-if="multipleRooms.switchContent == 'iframe'"
      :src="multipleRooms.switchContentConfig"
      frameborder="0"
      :style="{ width: '100%', height }"
      allow="fullscreen"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContentPage from './content_pages'

export default {
  components: {
    ContentPage
  },

  props: {
    layout: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapState('common', {
      rooms: state => state.rooms,
      multipleRooms: state => state.virtual.multipleRooms,
      innerWidth: state => state.innerWidth,
    }),
    height() {
      return this.layout === 'virtualMobile' ? `${this.innerWidth * 9 / 16}px` : '100%'
    }
  },
}
</script>
